module.exports = __webpack_public_path__ + "img/appAsset-brand--piriod.89347b7e.svg";